// src/components/HomeComponents/DemoSection.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/StudentComponents/StDemoSection.css';
import demoImage from '../../assets/Images/Group 228.webp'; // Make sure to have this image in assets

const StDemoSection = () => {
  
  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;

    try {
      // OPEN TIDYCAL IN SAME TAB — allows redirect to your website
      window.location.href = tidycalUrl;
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };


  return (
    <section className="st-demo-section">
      <div className="st-demo-content">
        <h2>
          Still have questions?
        </h2>
        <p>
        We'd love to help you find the perfect learning opportunity for yourself or someone you care about.
        </p>
        <button onClick={handleClick} className="st-demo-btn">Contact</button>
      </div>
      <div className="st-demo-image-container">
        <img src={demoImage} alt="Book a demo illustration" className='st-demo-image'/>
      </div>
    </section>
  );
};

export default StDemoSection;
